import { Divider } from "@mui/material";
import { FC } from "react";

const PaddedDivider: FC = () => {
  return <Divider variant={"middle"} flexItem sx={{ py: "1em" }} />;
};

export default PaddedDivider;
